import { useEffect, useMemo, useRef } from 'react'

import { resolveDashboardLastUpdated } from './insight-display'

/** Tracks server lastUpdatedAt across fetches for instrument / LOI dashboard headers. */
export function useDashboardLastUpdatedIso(
  serverLastUpdatedAt: string | null | undefined,
  dataUpdatedAt: number,
  scopeKey: string,
): string | undefined {
  const prevServerRef = useRef<string | null | undefined>(undefined)

  useEffect(() => {
    prevServerRef.current = undefined
  }, [scopeKey])

  const fetchedAtMs = dataUpdatedAt > 0 ? dataUpdatedAt : undefined

  const iso = useMemo(
    () =>
      resolveDashboardLastUpdated(
        serverLastUpdatedAt,
        fetchedAtMs,
        prevServerRef.current,
      ),
    [serverLastUpdatedAt, fetchedAtMs],
  )

  useEffect(() => {
    if (serverLastUpdatedAt != null) {
      prevServerRef.current = serverLastUpdatedAt
    }
  }, [serverLastUpdatedAt, dataUpdatedAt])

  return iso
}
